import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Select, Button,Tooltip, Modal } from 'antd';
import moment from 'moment';
import { CheckSquareTwoTone } from '@ant-design/icons/lib';
import { FlexGridSearch } from '@grapecity/wijmo.react.grid.search';
import * as wjInput from '@grapecity/wijmo.react.input';
import { FlexGrid, FlexGridColumn, FlexGridCellTemplate } from '@grapecity/wijmo.react.grid';
import { FlexGridFilter } from '@grapecity/wijmo.react.grid.filter';
import * as wijmo from '@grapecity/wijmo';
import * as wjcGridPdf from '@grapecity/wijmo.grid.pdf';
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import * as wjcPdf from '@grapecity/wijmo.pdf';
import '@grapecity/wijmo.styles/wijmo.css';
import { CollectionView, Globalize } from '@grapecity/wijmo';
import { CollectionViewNavigator } from '@grapecity/wijmo.react.input';
import { FilePdfTwoTone } from '@ant-design/icons/lib';

let columnPicker = [];
let flexes = '';
let showGrid = '';
let dragOver = '';
let listBoxes = '';
let i = 1;

class ExportService {
    startExcelExport(flex, successCallback, errorCallback, progressCallback) {
        wjcGridXlsx.FlexGridXlsxConverter.saveAsync(
            flex,
            {
                includeColumnHeaders: true,
                includeStyles: false
            },
            'TestDetail_OccHealth.xlsx',
            successCallback,
            errorCallback,
            progressCallback,
            true
        );
    }
    cancelExcelExport(doneCollback) {
        wjcGridXlsx.FlexGridXlsxConverter.cancelAsync(doneCollback);
    }
    exportToPdf(flex, options) {
        wjcGridPdf.FlexGridPdfConverter.export(flex, 'FlexGrid.pdf', {
            maxPages: 100,
            exportMode: wjcGridPdf.ExportMode.All,
            scaleMode: wjcGridPdf.ScaleMode.ActualSize,
            documentOptions: {
                pageSettings: {
                    layout: wjcPdf.PdfPageOrientation.Landscape
                },
                header: {
                    declarative: {
                        text: '\t&[Page]\\&[Pages]'
                    }
                },
                footer: {
                    declarative: {
                        text: '\t&[Page]\\&[Pages]'
                    }
                }
            },
            styles: {
                cellStyle: {
                    backgroundColor: '#ffffff',
                    borderColor: '#c6c6c6'
                },
                altCellStyle: {
                    backgroundColor: '#f9f9f9'
                },
                groupCellStyle: {
                    backgroundColor: '#dddddd'
                },
                headerCellStyle: {
                    backgroundColor: '#eaeaea'
                },
                errorCellStyle: {
                    backgroundColor: 'rgba(255, 0, 0, 0.3)'
                }
            },
            customCellContent: false
        });
    }

    _resetExcelContext(ctx) {
        ctx.exporting = false;
        ctx.progress = 0;
        ctx.preparing = false;
    }
}

const ClearanceData = ({
    data,
    clearanceDataPermission,
    downloadClearance,
    downloadAttachmentMultiple,
    clearanceDocPermission
}) => {
    const [view, setView] = useState();
    const [viewData, setViewData] = useState();
    const [isExcelExporting, setIsExcelExporting] = useState();
    const [isExcelPreparing, setIsExcelPreparing] = useState();
    const [excelProgress, setExcelProgress] = useState();
    const [listboxColumns, setListboxColumns] = useState([]);
    const [clearanceData, setClearanceData] = useState([]);
    const [itemsPerPage, setItemPerPage] = useState(10);
    const [pageSize, setPageSize] = useState(10);
    const theGrid = useRef();
    const theSearch = useRef();
    const fixedContainerRef = useRef(null);
    const filterRefCounter = useRef(null);
    let tt = new wijmo.Tooltip();

    useEffect(() => {
        data.sort((a, b) => {
            const dateA = new Date(a.scheduled_date);
            const dateB = new Date(b.scheduled_date);
            return dateB - dateA;
        })
        const ress = data.map((val) => {
            return {
                ...val,
                newLocation: val.loc_name.split('|')[1],
                newDate: val.scheduled_date ? val.scheduled_date : '',
                newDateForExcel: val.scheduled_date ? moment(val.scheduled_date).format('MM/DD/YYYY') : "",
                mode: val.mode != false ? val.mode : ''
            };
        });
        setClearanceData(ress);
    }, []);

    useEffect(() => {
        if (clearanceData.length > 0) {
            const collectionView1 = new CollectionView(clearanceData, {
                pageSize: clearanceData.length
            });
            setViewData(collectionView1);
            const collectionView2 = new CollectionView(clearanceData, {
                pageSize: pageSize,
                collectionChanged: (s) => {
                    filterRefCounter.current = s.totalItemCount;
                    var filterCounter = document.getElementById('filterCounter');
                    if (filterCounter) {
                        filterCounter.textContent = s.totalItemCount;
                    }
                }
            });
            setView(collectionView2);
        }
    }, [clearanceData, pageSize]);


    let theGrids = theGrid.current;
    let theSearchs = theSearch.current;
    if (theGrids && theSearchs) {
        theSearchs.control.grid = theGrids.control;
    }

    const paggination = (value) => {
        setItemPerPage(value);
        setPageSize(value);
        view.refresh();
    };

    const exportToExcel = () => {
        const exportService = new ExportService();
        const resetState = () => {
            setIsExcelPreparing(false);
            setIsExcelExporting(false);
            setExcelProgress(0);
        };
        if (!isExcelPreparing && !isExcelExporting) {
            setIsExcelPreparing(true);
            exportService.startExcelExport(
                flexes,
                () => {
                    console.log('Export to Excel completed');
                    resetState();
                },
                (err) => {
                    console.error(`Export to Excel failed: ${err}`);
                    resetState();
                },
                (prg) => {
                    setIsExcelPreparing(false);
                    setIsExcelExporting(true);
                    setExcelProgress(prg);
                }
            );
            console.log('Export to Excel started');
        } else {
            exportService.cancelExcelExport((progress) => {
                console.log('Export to Excel canceled');
                resetState();
            });
        }
    };

    const initializedListBox = (listbox) => {
        listBoxes = listbox;
    };

    const showPicker = (e) => {
        const reference = showGrid.hostElement.querySelector('.wj-topleft');
        wijmo.showPopup(listBoxes.hostElement, reference, false, true, false);
        listBoxes.focus();
        e.preventDefault();
    };
    const hidePicker = () => {
        wijmo.hidePopup(listBoxes.hostElement);
    };

    const formatItem = (sender, e) => {
        if (e.panel == sender.topLeftCells) {
            var span = document.createElement('span');
            span.className = 'column-picker-icon glyphicon glyphicon-cog';
            span.innerHTML = '&#9733';
            span.style.color = '#425a81';
            span.addEventListener('mousedown', function (e) {
                showPicker(e);
            });
            e.cell.appendChild(span);
        }
    };

    const gridInitialized = (ctl) => {
        ctl.select(-1, -1);
        showGrid = ctl;
        setListboxColumns(ctl.columns);
    };

    const gridInitializedData = (ctl) => {
        flexes = ctl;
    };

    const getSubItemSource = (item) => {
        const res = clearanceData.filter((value) => {
            if (value.id === item.item.id) {
                return value.test_name;
            }
        });

        const ress = res[0].test_name.map((val) => {
            return {
                ...val,
                newCompleteDate: val.testing_date ? val.testing_date : '',
                newCompleteDateForExcel: val.testing_date ? moment(val.testing_date).format('MM/DD/YYYY') : ''
            };
        });
        ress.sort((a, b) => {
            const dateA = new Date(a.newCompleteDate);
            const dateB = new Date(b.newCompleteDate);
            return dateB - dateA;
        })
        return ress;
    };

    const showStatus = (item) => {
        return <p>{item.item.event_status ? item.item.event_status : ''}</p>;
    };


    const showDocuments = (item) => {
        // const urls = item.item.urls;
        // const hasValidPdf = Array.isArray(urls) && urls.some(url => url !== null && url !== undefined && url !== "");
        
        return (
            <p>
                {clearanceDocPermission && item.item.test_status=="Completed" && clearanceDataPermission && item.item.event_id && item.item.emp_selected && item.item.test_detail_id ? (
                    <FilePdfTwoTone
                        onClick={(e) => downloadClearance(e, item.item.event_id, item.item.emp_selected,item.item.test_detail_id)}
                        style={{ fontSize: '15px', width: '60px', cursor: 'pointer' }}
                        twoToneColor='#FF0000'
                    />
                ) :null}
            </p>
        );
    };

    const showResult = (item) => {
        return <p>{item.item.final_result ? item.item.final_result : ''}</p>;
    };

    const showTestName = (item) => {
        return <p>{item.item.test_name_moved0 ? item.item.test_name_moved0 : ''}</p>;
    };

    const showExpandStatus = (item) => {
        return <p>{item.item.test_status ? item.item.test_status : ''}</p>;
    };

    const showCompledOn = (item) => {
        return (
            <p>{item.item.testing_date ? moment(item.item.testing_date).format('MM/DD/YYYY') : ''}</p>
        );
    };

    const showDoc = (item) => {
        return (
            <p>
                {clearanceDataPermission && item.item.urls && item.item.urls.length > 0
                    ? item.item.urls.map((url) => {
                        return (
                            <>
                                <FilePdfTwoTone
                                    onClick={() => downloadAttachmentMultiple(url)}
                                    style={{ fontSize: '15px', width: '60px', cursor: 'pointer' }}
                                    twoToneColor='#FF0000'
                                />
                            </>
                        );
                    })
                    : item.item.urls &&
                    item.item.urls.length > 0 && (
                        <CheckSquareTwoTone style={{ color: 'green', fontSize: 15 }} />
                    )}
            </p>
        );
    };

        const openTextNotesModal = (text) => {
       Modal.info({
        title: (
        <span style={{ color: '#000', fontWeight: 600 }}>
            Full Notes
        </span>
        ),
        width: 600,
        icon: null,
        closable: true,
        maskClosable: true,
        okButtonProps: { style: { display: 'none' } },
        content: (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <p style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
            {text}
            </p>
        </div>
        ),
    });
    };

    const showTdMessage = (item) => {
  const text = item?.item?.event_note || '';

  const isLongText = text.length > 40;

  const truncatedText =
    isLongText ? text.substring(0, 37) + '...' : text;

  return (
    <Tooltip title={text}>
      <span
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          if (isLongText) {
            openTextNotesModal(text);
          }
        }}
        style={{
          cursor: isLongText ? 'pointer' : 'default',
        }}
      >
        {truncatedText}
      </span>
    </Tooltip>
  );
};

    return (
        <div>
            <Row gutter={[32, 32]}>
                <Col xs={24} sm={8} md={8} lg={8} xl={10}>
                    <FlexGridSearch
                        ref={theSearch}
                        placeholder='Search'
                        cssMatch=''
                        style={{ width: '70%', height: '40px' }}
                    />
                </Col>

                <Col xs={12} sm={8} md={8} lg={8} xl={4} style={{ textAlign: 'center' }}>
                    <div ref={fixedContainerRef}>
                        <Select
                            style={{ width: 170 }}
                            placeholder={`Items per page : ${pageSize}`}
                            onChange={paggination}
                            options={[
                                { label: 'Items per page : 10', value: 10 },
                                { label: 'Items per page : 20', value: 20 },
                                { label: 'Items per page : 50', value: 50 }
                            ]}
                            getPopupContainer={() => fixedContainerRef.current}
                        />
                    </div>
                </Col>

                <Col xs={12} sm={8} md={8} lg={8} xl={10}>
                    <Button
                        type='primary'
                        size='small'
                        style={{ backgroundColor: '#3d586a', float: 'right' }}
                        disabled={isExcelPreparing}
                        onClick={exportToExcel}
                    >
                        {isExcelExporting ? `Cancel (${excelProgress}% done)` : 'Export To Excel'}
                    </Button>
                </Col>
            </Row>

            <FlexGrid
                ref={theGrid}
                style={{ display: 'none' }}
                className='dummyWijmoData'
                itemsSource={viewData}
                initialized={gridInitializedData}
                formatItem={formatItem}
                isReadOnly={true}
            >
                <FlexGridColumn binding='test_name_moved0' header='Test Name' width={275}>
                    <FlexGridCellTemplate cellType='Cell' template={showTestName} />
                </FlexGridColumn>
                <FlexGridColumn binding='final_result' header='Result' minWidth={140} width='*' />
                <FlexGridColumn binding='test_status' header='Status' width='*' minWidth={170}>
                    <FlexGridCellTemplate cellType='Cell' template={showExpandStatus} />
                </FlexGridColumn>
                <FlexGridColumn binding='event_id' header='Documents' minWidth={170} width='*'>
                    <FlexGridCellTemplate cellType='Cell' template={showDocuments} />
                </FlexGridColumn>
                <FlexGridColumn binding='event_note' header='Notes' minWidth={230} width='*'>
                    <FlexGridCellTemplate cellType='Cell' template={showTdMessage} />
                </FlexGridColumn>
                <FlexGridColumn
                    binding='eventNotes'
                    header='Notes'
                    minWidth={150}
                    width='*'
                ></FlexGridColumn>
            </FlexGrid>

            <FlexGrid
                autoGenerateColumns={false}
                ref={theGrid}
                id='theGridTallRows'
                className='cliniclisttable'
                alternatingRowStep={1}
                itemsSource={view}
                initialized={gridInitialized}
                formatItem={formatItem}
                itemsPerPage={10}
                isReadOnly={true}
                scrollMode='Virtual'
            >
                <div style={{ display: 'none' }}>
                    <wjInput.ListBox
                        className='column-picker'
                        itemsSource={listboxColumns}
                        checkedMemberPath='visible'
                        displayMemberPath='header'
                        lostFocus={hidePicker}
                        initialized={initializedListBox}
                    ></wjInput.ListBox>
                </div>
                <FlexGridColumn binding='test_name_moved0' header='Test Name' width={275}>
                    <FlexGridCellTemplate cellType='Cell' template={showTestName} />
                </FlexGridColumn>
                <FlexGridColumn binding='final_result' header='Result' width={150}>
                    <FlexGridCellTemplate cellType='Cell' template={showResult} />
                </FlexGridColumn>
                <FlexGridColumn binding='event_status' header='Status' width={150}>
                    <FlexGridCellTemplate cellType='Cell' template={showExpandStatus} />
                </FlexGridColumn>
                <FlexGridColumn binding='newCompleteDate' header='Test Date' width={170}>
                    <FlexGridCellTemplate cellType='Cell' template={showCompledOn} />
                </FlexGridColumn>
                <FlexGridColumn binding='event_id' header='Documents' width={170}>
                    <FlexGridCellTemplate cellType='Cell' template={showDocuments} />
                </FlexGridColumn>
                <FlexGridColumn binding='event_note' header='Notes' width={265}>
                    <FlexGridCellTemplate cellType='Cell' template={showTdMessage} />
                </FlexGridColumn>

                <FlexGridFilter
                    filterColumns={[
                        'reasons',
                        'package_name',
                        'event_status',
                        'final_result',
                        'test_name_moved0',
                        'newCompleteDate',
                        'event_note'
                    ]}
                />
            </FlexGrid>
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <div
                    style={{
                        backgroundColor: '#425a81',
                        color: '#fff',
                        display: 'inline',
                        borderRadius: '5px',
                        height: '30px'
                    }}
                >
                    <CollectionViewNavigator
                        style={{ color: '#fff', backgroundColor: '#425a81', height: '30px' }}
                        headerFormat='Page {currentPage:n0} of {pageCount:n0}'
                        byPage={true}
                        cv={view}
                    />
                </div>
                &nbsp;&nbsp;&nbsp;
                <p
                    style={{ fontWeight: 'bold', verticalAlign: 'baseline', fontSize: '14px' }}
                    ref={filterRefCounter}
                    id='filterCounter'
                >
                    {Globalize.format(filterRefCounter.current, 'n0')}
                </p>
                &nbsp;
                <p style={{ fontWeight: 'bold', verticalAlign: 'baseline', fontSize: '14px' }}>
                    {' '}
                    out of {clearanceData.length}
                </p>
            </div>
        </div>
    );
};

export default ClearanceData;
